import React, { Component } from 'react';
import moment from 'moment';
import { classNames, isEqualShallow, isFunction, isMobile, key } from '@philips-internal/oswald-ui-utils';
import { Loader } from '../../loader/loader.js';
import { DatePickerMode } from '../date-picker-constants.js';
import { DatePickerAcronyms } from './date-picker-acronyms.js';
import { DatePickerRow } from './date-picker-row.js';
class DatePickerContent extends Component {
    constructor() {
        super(...arguments);
        this.touchClientStart = 0;
        this.state = {
            currentWeek: undefined,
            isWeekOpen: false,
            mappedData: [],
        };
        this.mapData = () => {
            const { data } = this.props;
            this.setState({ mappedData: this.getDataRange(data) });
        };
        this.onCellClick = ({ date }) => {
            const { enabled, onClick } = this.props;
            if (enabled && isFunction(onClick)) {
                onClick(date);
            }
        };
        this.getDataRange = (dataRange) => {
            const { monthDate, mode } = this.props;
            if (mode === DatePickerMode.MONTHLY && monthDate) {
                const lastDataItem = dataRange[dataRange.length - 1][0].date;
                if (!monthDate.isSame(lastDataItem, 'month') || !monthDate.isSame(lastDataItem, 'year')) {
                    dataRange.pop();
                }
            }
            return dataRange;
        };
        this.renderLoading = () => {
            const { loading } = this.props;
            if (!loading) {
                return null;
            }
            return (React.createElement(Loader, { centered: true, className: "c-datepicker__loader u-hide@empty", size: isMobile() ? 32 : 64 }));
        };
        this.renderSpecialDays = () => {
            const { data } = this.props;
            const specialDays = [];
            data.forEach(week => week.forEach(day => day.specialDay && specialDays.push(day)));
            if (!specialDays.length) {
                return null;
            }
            return (React.createElement("div", { className: "c-date-picker__special-dates" }, specialDays.map((day, index) => {
                const date = moment.utc(day.specialDay?.date);
                return (React.createElement("div", { className: "c-date-picker__special-date", key: index },
                    React.createElement("div", { className: "c-date-picker__special-date-day" }, date.format('D')),
                    React.createElement("span", null, day.specialDay?.description)));
            })));
        };
        this.handleTouchEnd = (event) => {
            const { enabled, onArrowClick } = this.props;
            if (!isMobile() || !isFunction(onArrowClick) || !enabled) {
                return;
            }
            const touchClientEnd = event.changedTouches[0].clientX;
            if (Math.abs(this.touchClientStart - touchClientEnd) < 50) {
                return;
            }
            if (touchClientEnd < this.touchClientStart) {
                onArrowClick(1);
            }
            else {
                onArrowClick(-1);
            }
        };
        this.handleTouchStart = (event) => {
            const { enabled } = this.props;
            if (!isMobile() || !enabled) {
                return;
            }
            this.touchClientStart = event.touches[0].clientX;
        };
    }
    componentDidMount() {
        this.mapData();
    }
    componentDidUpdate(previousProps, previousState) {
        const { data } = this.props;
        const { isWeekOpen } = this.state;
        const { isWeekOpen: prevIsWeekOpen } = previousState;
        if (!isEqualShallow(previousProps.data, data) || isWeekOpen !== prevIsWeekOpen) {
            this.mapData();
        }
    }
    renderAcronyms() {
        const { currentDate, data } = this.props;
        const shouldHighlightWeek = data.find(weeks => weeks.find(day => moment(day.date).isSame(currentDate)));
        const shouldRenderAcronyms = this.props.mode === DatePickerMode.MONTHLY || this.props.mode === DatePickerMode.WEEK;
        return shouldRenderAcronyms
            ? React.createElement(DatePickerAcronyms, { currentDay: shouldHighlightWeek ? currentDate : undefined })
            : null;
    }
    render() {
        const { isWeekOpen, mappedData = [] } = this.state;
        const { currentDate, enabled, endDate, interval, intervalThreshold, loading, mode, monthDate, rangeEnabled, ranges, startDate } = this.props;
        const className = classNames({
            'c-date-picker__rows': true,
            'c-date-picker__week-open': !isWeekOpen,
        });
        return (React.createElement("div", { className: "c-date-picker__content" },
            this.renderAcronyms(),
            this.renderLoading(),
            React.createElement("div", { className: className, onTouchEnd: this.handleTouchEnd, onTouchStart: this.handleTouchStart }, mappedData.map((week) => (React.createElement(DatePickerRow, { currentDate: currentDate, enabled: enabled, endDate: endDate, interval: interval, intervalThreshold: intervalThreshold, key: key('c-date-picker-row'), loading: loading, mode: mode, monthDate: monthDate, onCellClick: this.onCellClick, rangeEnabled: rangeEnabled, ranges: ranges, row: week, startDate: startDate })))),
            this.renderSpecialDays()));
    }
}
export { DatePickerContent, };
//# sourceMappingURL=date-picker-content.js.map